class TemperatureObservations {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.initialize();
  }

  initialize() {
    this.evaluateNewPositions();
    this.bindEvents();
  }

  bindEvents() {
    // Handle add field button
    this.wrapper.addEventListener('click', (e) => {
      if (e.target.closest('.addField')) {
        setTimeout(() => {
          this.evaluateNewPositions();
        }, 500);
      }
    });

    // Handle up/down arrows
    this.wrapper.addEventListener('click', (e) => {
      if (e.target.closest('.present-up-arrow')) {
        e.preventDefault();
        this.moveRecord(e.target.closest('.present-up-arrow'), -1);
      } else if (e.target.closest('.present-down-arrow')) {
        e.preventDefault();
        this.moveRecord(e.target.closest('.present-down-arrow'), 1);
      }
    });

    // Handle remove field button
    this.wrapper.addEventListener('click', (e) => {
      if (e.target.closest('.remove-present-field')) {
        setTimeout(() => {
          this.evaluateNewPositions();
        }, 500);
      }
    });
  }

  evaluateNewPositions() {
    const visibleNestedFields = Array.from(this.wrapper.querySelectorAll('.nested-fields')).filter(el => {
      return el.offsetParent !== null;
    });

    visibleNestedFields.forEach((nestedField, index) => {
      const pos = nestedField.querySelector('.record-position');
      if (pos) {
        pos.value = index;
        pos.className = `record-position recordPosition-${index}`;
      }
    });
  }

  moveRecord(arrowElement, direction) {
    const parentRow = arrowElement.closest('.record-row');
    const recordRow = parentRow.querySelector('.row');
    const position = parseInt(parentRow.querySelector('.record-position').value);
    const newPosition = position + direction;
    const visibleNestedFields = Array.from(this.wrapper.querySelectorAll('.nested-fields')).filter(el => {
      return el.offsetParent !== null;
    });
    const recordSize = visibleNestedFields.length;

    if ((direction === -1 && newPosition >= 0) || (direction === 1 && newPosition < recordSize)) {

      for (let index = 0; index < recordSize; index++) {
        const nestedField = visibleNestedFields[index];
        const targetParentRow = nestedField.querySelector(`.recordPosition-${newPosition}`)?.closest('.record-row');
        if (targetParentRow) {
          const targetRecordRow = targetParentRow.querySelector('.row');

          // Clone the rows
          const recordRowClone = recordRow.cloneNode(true);
          const targetRecordRowClone = targetRecordRow.cloneNode(true);

          // Replace the rows
          parentRow.replaceChild(targetRecordRowClone, recordRow);
          targetParentRow.replaceChild(recordRowClone, targetRecordRow);

          this.evaluateNewPositions();

          break;
        }
      }
    }
  }
}

// Initialize when document is ready
document.addEventListener('turbolinks:load', () => {
  const wrapper = document.querySelector('.temperature-observations-wrapper');
  if (wrapper) {
    new TemperatureObservations(wrapper);
  }
}); 